import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, filterCities, getCitySubdivisions, showAxiosError, trimObject} from "../../util/Helpers";
import {DatePicker, Form, input, Switch} from "antd";
import Select from "react-select"
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import moment from "moment";
import {Label, UncontrolledTooltip} from "reactstrap";
import './DocumentList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import UploaderDocument from "../../components/Uploader/UploaderDocument";
import 'react-datetime/css/react-datetime.css';

const { TextArea } = input;

class DocumentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            documentFile: [],
            fieldsDisabled: false,
            mode: this.props.mode,
            outstandingAccruals: [],
            inActivateMemberModal: false,
            selectedUsers: null,
            selectedGroups: null,
            notes: [],
            files: [],
            documentInfo: {
                selectedUsers: null,
                selectedGroups: [],
                evrakNo: null,
                evrakKonu: "",
                evrakAciklama: "",
                evrakIlgiliYer: "",
                evrakTipi: null,
                belgeTuru: "",
                eimzaliMi: true,
                sureliMi: false,
                sureBitisTarihi: null,
                sevkGroupId: null,
                sevkUserId: null,
                evrakPath: "",
                evrakFile: "",
                id: null,
                ad: "",
                soyad: "",
                unemployed: false,
            },
        };

        this.saveDocument = this.saveDocument.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeDocument = this.onChangeDocument.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
        this.fileDocuments = this.fileDocuments.bind(this); // Doğru metod adı
        this.getDocumentFile = this.getDocumentFile.bind(this);
        this.noteDocuments = this.noteDocuments.bind(this); // Doğru metod adı
    }

    componentDidMount() {
        if (this.state.mode === 'review') {
            this.setState({ fieldsDisabled: true });
        }
        if (this.props.selectedDocument && this.props.selectedDocument.id) {
            let selectedDocument = deepCopyObject(this.props.selectedDocument);
            if (!selectedDocument.belgeTuru) selectedDocument.belgeTuru = '';
            selectedDocument.sureBitisTarihi = selectedDocument.sureBitisTarihi ? moment.utc(selectedDocument.sureBitisTarihi, "YYYY-MM-DD") : null;

            this.setState({
                documentInfo: selectedDocument,
                documentInfo1: selectedDocument,
            });

            if (selectedDocument.isTransferred) {
                this.setState({ fieldsDisabled: true });
            }

            this.handleEvrakClick(selectedDocument.id);
            this.fetchNotesAndFiles(selectedDocument.id);
        } else {
            console.error("selectedDocument.id is not defined");
        }
    }


    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }
    onChangeSelect(name, value) {
        let documentInfo = this.state.documentInfo;
        if (value === null) {
            documentInfo[name] = null
        } else {
            documentInfo[name] = value.value;
        }
        this.setState({documentInfo});
    }
    onSelectInfoChange(name,value){
        let documentInfo=this.state.documentInfo;
        if(value===null) {
            documentInfo[name]=[];
        }
        else {
            documentInfo[name]=[];
            documentInfo[name]=value.slice();
        }
        this.setState({documentInfo });
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChangeDocument(name, value) {

        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        // let documentInfo = this.state.documentInfo;
        // documentInfo[name] = value;
        // this.setState({documentInfo});
        let files = this.state.files;
        files[name] = value.toString().toLocaleLowerCase();
        this.setState({files});
    }

    onChangeDateString(name, value) {
        if (value === "") {
            value = null;
        }
        if (value !== null) {
            let splitted = value.split(".");
            value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
        }
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value;
        this.setState({documentInfo});
    }

    onChangeDocumentUpperCase(name, value) {
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value.toString().toLocaleUpperCase();
        this.setState({documentInfo});
    }

    onChangeDocumentLowerCase(name, value) {
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value.toString().toLocaleLowerCase();
        this.setState({documentInfo});
    }

    onChangeDocumentCheckbox(name, value) {
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value;
        this.setState({documentInfo});
    }

 onChangeDocumentNote = (field, value) => {
     this.setState(prevState => {
         // Önce mevcut notlar dizisini kopyalayalım
         let updatedNotes = [...prevState.notes];

         // Yeni notu bulalım veya oluşturup diziye ekleyelim
         let newNote = updatedNotes.find(note => note.id === null);
         if (newNote) {
             newNote[field] = value;
         } else {
             newNote = { [field]: value, id: null, evrakSevkId: prevState.documentInfo.id };
             updatedNotes.push(newNote);
         }

         return { notes: updatedNotes };
     });
 };

onChangeDocumentFile = (field, value) => {
    this.setState(prevState => {
        let updatedFiles = [...prevState.files];
        let newFile = updatedFiles.find(file => file.id === null);
        if (newFile) {
            newFile[field] = value;
        } else {
            newFile = { [field]: value, id: null, evrakSevkId: prevState.documentInfo.id };
            updatedFiles.push(newFile);
        }
        return { files: updatedFiles };
    });
};


    onSelectChange(name, value) {
        let documentInfo = this.state.documentInfo;
        if (value === null) {
            documentInfo[name] = null
        } else {
            documentInfo[name] = value.value;
        }
        this.setState({documentInfo});
    }


    saveDocument(action) {
        let self = this;
        let params;
        let data;
        let message;
        self.setState({ isLoading: true });
        let document = deepCopyObject(this.state.documentInfo);
        document = trimObject(document);
        data = document;

        if (document.id === null) {
            message = 'Evrak Bilgileri Başarıyla Kaydedildi.'
            params = {
                url: API_BASE_URL + "/evrakSevk",
                data: data,
                method: 'post'
            };
        } else {
            message = 'Evrak Bilgileri Başarıyla Güncellendi.'
            params = {
                url: API_BASE_URL + "/evrakSevk/updateEvrakSevk",
                data: data,
                method: 'patch'
            };
        }

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({ isLoading: false });
            if (document.id !== null) {
                this.noteDocuments();
                this.fileDocuments();
            }
            this.cancelProcess();
            self.props.handleSearch(self.props.searchQuery, true);
        }).catch(function (error) {
            self.setState({ isLoading: false });
            showAxiosError(error);
        });
    }

 noteDocuments() {
     let self = this;
     self.setState({ isLoading: true });

     let newNote = this.state.notes.find(note => note.id === null && note.not !== null && note.not.trim() !== "");
     console.log("New Note:", newNote);
     if (!newNote) {
         self.setState({ isLoading: false });

         return;
     }

     let payload = {
         id: newNote.id,
         not: newNote.not,
         cuser: newNote.cuser || null,
         cdate: newNote.cdate || null,
         evrakSevkId: newNote.evrakSevkId
     };

     let params = {
         url: API_BASE_URL + "/evrakSevkNot/",
         data: payload,
         method: 'post'
     };

     request(params).then(response => {
         console.log("Response Data:", response.data);
         Alert.success(
             'Not Başarıyla Kaydedildi.', {
                 position: 'top-right',
                 effect: 'stackslide',
                 timeout: 5000
             }
         );
         self.setState(prevState => ({
             isLoading: false,
             notes: prevState.notes.map(note => note.id ? note : response.data)
         }));
         this.cancelProcess();
         self.props.handleSearch(self.props.searchQuery, true);
     }).catch(error => {
         self.setState({ isLoading: false });
         showAxiosError(error);
         console.error("Error response:", error.response);
     });
 }



 fileDocuments() {
     let self = this;
     self.setState({ isLoading: true });

     // Undefined kontrolü ekleyin
     let newFile = this.state.files.find(file => file && file.id === null && file.file && file.file.trim() !== "");
     if (!newFile) {
         self.setState({ isLoading: false });
         return;
     }

     let formData = new FormData();
     formData.append('file', newFile.file);
     formData.append('evrakSevkId', newFile.evrakSevkId);

     let params = {
         url: API_BASE_URL + "/evrakSevkNotFile",
         data: formData,
         method: 'post',
         headers: {
             'Content-Type': 'multipart/form-data',
             'Authorization': 'Bearer ' + this.props.authToken
         }
     };

     request(params).then(response => {
         Alert.success(
             'Dosya Başarıyla Kaydedildi.', {
                 position: 'top-right',
                 effect: 'stackslide',
                 timeout: 5000
             }
         );
         self.setState(prevState => ({
             isLoading: false,
             files: prevState.files.map(file => file.id ? file : response.data)
         }));
         this.cancelProcess();
         self.props.handleSearch(self.props.searchQuery, true);
     }).catch(error => {
         self.setState({ isLoading: false });
         showAxiosError(error);
         console.error("Error response:", error.response);
     });
 }

handleEvrakClick = (evrakId) => {
   if (evrakId) {
       this.getDocumentFile(evrakId);
   } else {
       console.error("Evrak ID is not defined");
   }
}

getDocumentFile = (evrakId) => {
   if (!evrakId) {
       console.error("Evrak ID is not defined");
       return;
   }
   let self = this;
   let params = {
      url: `${API_BASE_URL}/evrakSevk/${evrakId}/details`,
       method: "get",
   };
   request(params)
       .then(function (response) {
           let content = response.data.content;
           console.log("documentFile", response.data.content)
           self.setState({
               documentFile: {
                   ...self.state.documentFile,
                   content
               },
           }, () => {console.log("newDocumentFile::", self.state.documentFile)});
       }).catch(function (error) {
       showAxiosError(error);
   });
}

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }
     fetchNotesAndFiles = (documentId) => {
            request({
                url: `${API_BASE_URL}/evrakSevk/${documentId}/details`,
                method: "get",
            }).then(response => {
                this.setState({ notes: response.data.notes, files: response.data.files });
            }).catch(showAxiosError);
        }



    render() {
     const { documentInfo, notes, files, isLoading } = this.state;
            const { selectedDocument } = this.props;


        const BelgeTipiOptions = [
            {label: 'DİPLOMA', value: 'DIPLOMA'},
            {label: 'GÖZLÜKÇÜLÜK RUHSATNAMESİ', value: 'RUHSATNAME'},
            {label: 'GEÇİCİ MEZUNİYET BELGESİ', value: 'GECICI_MEZUNIYET'}
        ]

        let sureBitisTarihi = this.state.documentInfo.sureBitisTarihi ? {value: moment.utc(this.state.documentInfo.sureBitisTarihi, "YYYY.MM.DD")} : {};

        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Evrak Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Oda İl: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('todaIl')}>
                                    {/*<Select*/}
                                    {/*    className="basic-single"*/}
                                    {/*    disabled={this.state.citySelectionDisabled}*/}
                                    {/*    classNamePrefix="select"*/}
                                    {/*    placeholder="İl seçiniz."*/}
                                    {/*    isClearable={false}*/}
                                    {/*    isSearchable={true}*/}
                                    {/*    name="city"*/}
                                    {/*    id="tCity"*/}
                                    {/*    ref="tCity"*/}
                                    {/*    onBlur={this.validateField}*/}
                                    {/*    style={{width: 160, minWidth: 160}}*/}
                                    {/*    inputProps={{'vdata': "required"}}*/}
                                    {/*    options={this.state.workAdrsCities}*/}
                                    {/*    onChange={(value) => this.onCityInfoChange("id", value)}*/}
                                    {/*    value={this.state.documentInfo.city.id}/>*/}
                                    <input className="form-control uppercase"
                                           disabled
                                           type="text"
                                           name="odaIl"
                                           id="odaIl"
                                           maxLength="50"
                                           data-vlength="3,50"
                                           onBlur={this.validateField}
                                           ref="todaIl"
                                           value="Şanlıurfa"
                                        // value={this.state.documentInfo.odaIl || ""}
                                           onChange={(e) => this.onChangeDocumentLowerCase("odaIl", e.target.value)}
                                    />
                                    {this.validateMessage('odaIl') !== "" &&
                                        <UncontrolledTooltip placement="right" target="odaIl" delay={0}>
                                            {this.validateMessage("odaIl")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            {/*{(this.state.documentInfo.id !== null) &&*/}
                            <div className='row'>
                                <label className="col-sm-3">Evrak No: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakNo')}>
                                    <input className="form-control"
                                           // disabled={this.props.selectedDocument}
                                           type="text"
                                           name="evrakNo"
                                           id="evrakNo"
                                           // maxLength="9"
                                           // data-vlength="9"
                                        // inputProps={{'vdata': "required", 'vlength': "9"}}
                                           onBlur={this.validateField}
                                           ref="evrakNo"
                                           value={this.state.documentInfo.evrakNo}
                                           onChange={(e) => this.onChangeDocument("evrakNo", e.target.value)}
                                    />
                                    {this.validateMessage('evrakNo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="evrakNo" delay={0}>
                                            {this.validateMessage("evrakNo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">İlgili Yer: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakIlgiliYer')}>
                                    <input className="form-control uppercase"
                                           // disabled={this.props.selectedDocument}
                                           type="text"
                                           name="evrakIlgiliYer"
                                           id="evrakIlgiliYer"
                                           maxLength="50"
                                           data-vlength="3,50"
                                           onBlur={this.validateField}
                                           ref="evrakIlgiliYer"
                                           value={this.state.documentInfo.evrakIlgiliYer || ""}
                                           onChange={(e) => this.onChangeDocumentLowerCase("evrakIlgiliYer", e.target.value)}
                                    />
                                    {this.validateMessage('evrakIlgiliYer') !== "" &&
                                        <UncontrolledTooltip placement="right" target="evrakIlgiliYer" delay={0}>
                                            {this.validateMessage("evrakIlgiliYer")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">Evrak Adı: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakKonu')}>
                                    <input className="form-control uppercase"
                                           // disabled={this.props.selectedDocument}
                                           type="text"
                                           name="evrakKonu"
                                           id="evrakKonu"
                                           maxLength="50"
                                           data-vlength="1,50"
                                           onBlur={this.validateField}
                                           ref="tUsername"
                                           value={this.state.documentInfo.evrakKonu || ""}
                                        // value="Başvuru Dilekçesi"
                                           onChange={(e) => this.onChangeDocumentLowerCase("evrakKonu", e.target.value)}
                                    />
                                    {this.validateMessage('tUsername') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tUsername" delay={0}>
                                            {this.validateMessage("tUsername")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Evrak Türü:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('belgeTuru')}>
                                    { this.props.selectedDocument ?
                                        <input
                                            className="form-control"
                                            // disabled
                                            type="text"
                                            name="belgeTuru"
                                            id="belgeTuru"
                                            ref="belgeTuru"
                                            style={{flex: 1}}
                                            defaultValue={this.state.documentInfo.belgeTuru || ""}
                                            inputProps={{'vdata': "required"}}
                                            // options={BelgeTipiOptions}
                                            onChange={(value) => this.onSelectChange("belgeTuru", value)}
                                            // onChange={(e) => this.onChangeDocumentLowerCase('belgeTuru', e.target.value)}
                                        />
                                        :
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            placeholder="Seçiniz"
                                            isClearable={false}
                                            isSearchable={false}
                                            type="text"
                                            name="belgeTuru"
                                            id="belgeTuru"
                                            ref="belgeTuru"
                                            style={{flex: 1}}
                                            // value={this.state.documentInfo.belgeTuru || ""}
                                            inputProps={{'vdata': "required"}}
                                            options={BelgeTipiOptions}
                                            onChange={(value) => this.onSelectChange("belgeTuru", value)}
                                            // onChange={(e) => this.onChangeDocumentLowerCase('belgeTuru', e.target.value)}


                                        />
                                    }
                                    {this.validateMessage('belgeTuru') !== "" &&
                                        <UncontrolledTooltip placement="right" target="belgeTuru" delay={0}>
                                            {this.validateMessage("belgeTuru")}
                                        </UncontrolledTooltip>}

                                </div>
                            </div>
                            <div className="row">
                                <Label className="col-sm-3">Geçerlilik Tarihi:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('sureBitisTarihi')}>
                                    <DatePicker {...sureBitisTarihi}
                                                className="basic-single"
                                                placeholder="Tarih seçiniz."
                                                // disabled={this.props.selectedDocument}
                                                classNamePrefix="select"
                                                format="DD.MM.YYYY"
                                                isClearable={true}
                                                isSearchable={true}
                                                name="sureBitisTarihi"
                                                id="sureBitisTarihi"
                                                ref="sureBitisTarihi"
                                                style={{width: "100%"}}
                                                inputProps={{'vdata': "required"}}
                                                onChange={(date) => this.onChangeDocument("sureBitisTarihi", date)}/>
                                    {this.validateMessage('sureBitisTarihi') !== "" &&
                                        <UncontrolledTooltip placement="right" target="sureBitisTarihi" delay={0}>
                                            {this.validateMessage("sureBitisTarihi")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                            <div>
                                <div className="row">
                                    <Label className="col-sm-3">Dosya:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('evrakPath')}>
                                        <a className="form-control"
                                           id="evrakPath"
                                           href={this.props.selectedDocument && this.props.selectedDocument.evrakPath}
                                           target="_blank"
                                            // onChange={(e) => this.onChangeDocumentUpperCase("evrakPath")}
                                        >
                                            {this.props.selectedDocument && this.props.selectedDocument.evrakPath || ""}
                                        </a>
                                        {this.validateMessage('evrakPath') !== "" &&
                                        <UncontrolledTooltip placement="right" target="evrakPath" delay={0}>
                                            {this.validateMessage("evrakPath")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <label className="col-sm-3">Süreli Evrak: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('sureliMi')} style={{display:"flex", gap:"5px"}}>
                                    <input className="form-control uppercase"
                                           type="checkbox"
                                           name="sureliMi"
                                           id="sureliMi"
                                           checked={this.state.documentInfo.sureliMi}
                                           onChange={(e) => this.onChangeDocumentCheckbox("sureliMi", e.target.checked)}
                                    />
                                    <h6>{this.state.documentInfo && this.state.documentInfo.sureliMi ? "Evet" : "Hayır"}</h6>
                                </div>
                            </div>
                        </div>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Açıklama</span>
                            <div className="row">
                                <Label className="col-sm-3">Evrak açıklaması: </Label>
                                <div
                                    className={"col-sm-8 form-group" + this.validateClass('evrakAciklama')}>
                                    <input className="form-control uppercase"
                                           disabled={this.state.fieldsDisabled}
                                           type="textarea"
                                           name="evrakAciklama"
                                           id="evrakAciklama"
                                           maxLength="255"
                                           data-vlength="1,250"
                                           ref="evrakAciklama"
                                           value={this.state.documentInfo.evrakAciklama || ""}
                                        // value="Başvuru Dilekçesi"
                                           onChange={(e) => this.onChangeDocumentLowerCase("evrakAciklama", e.target.value)}
                                    />
                                    {this.validateMessage('evrakAciklama') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakAciklama"
                                                         delay={0}>
                                        {this.validateMessage("evrakAciklama")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>

                        {   this.props.selectedDocument !== null &&
                            this.props.selectedDocument !== "null" &&
                            this.props.selectedDocument !== undefined &&
                            this.state.documentFile &&
                            this.state.documentFile.content &&
                            this.state.documentFile.content.length > 0 &&
                            <div className="FormRenk col-sm-12">
                                <span className="form-title">Dosya</span>
                                <div className="row">
                                    <Label className="col-sm-3">Dosya: </Label>
                                    <div
                                        className={"col-sm-8 form-group" + this.validateClass('evrakAciklama')}>
                                        {this.state.documentFile.content.map((name) =>
                                           <div>
                                               <label className="mt-1">Ekleyen Kişi</label>
                                               <a className="form-control" style={{overflowX:"scroll"}} id="aciklama" href={name.path} target="blank">
                                                   {name.path}
                                               </a>
                                           </div>
                                        )}
                                        {this.validateMessage('evrakAciklama') !== "" &&
                                        <UncontrolledTooltip placement="right" target="evrakAciklama"
                                                             delay={0}>
                                            {this.validateMessage("evrakAciklama")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        }
                      {selectedDocument && (notes.length > 0 || files.length > 0) && (
                                          <div className="FormRenk col-sm-12">
                                              <span className="form-title">Notlar ve Dosyalar</span>
                                              {notes.map((note, index) => (
                                                  <div key={note.id} className="row">
                                                      <Label className="col-sm-3">Not {index + 1}: </Label>
                                                      <div className="col-sm-8 form-group">
                                                          <TextArea value={note.not || "Not alanı boş bırakılmış"} readOnly />
                                                      </div>
                                                  </div>
                                              ))}
                                              {files.map((file, index) => (
                                                  <div key={file.id} className="row">
                                                      <Label className="col-sm-3">Dosya {index + 1}: </Label>
                                                      <div className="col-sm-8 form-group">
                                                          <a href={file.path} target="_blank">{file.path || "Dosya eklenmemiş"}</a>
                                                      </div>
                                                  </div>
                                              ))}
                                          </div>
                                      )}

                                      {/* Dosya yükleme alanı */}
                                      <div className="FormRenk col-sm-12">
                                          <span className="form-title">Dosya Yükleme</span>
                                          <div className="row">
                                              <Label className="col-sm-3">Evrak Yükle: </Label>
                                              <div className="col-sm-8 form-group">
                                                  <UploaderDocument onInfoChange={(field, value) => this.onChangeDocumentFile(field, value)}
                                                      thumbFileName="fotoThumbFile"
                                                      filePathName="path"
                                                      filePath={this.state.documentInfo.evrakPath}
                                                  />
                                              </div>
                                          </div>
                                      </div>

                              );
                          }


                      {this.props.selectedDocument !== null && this.props.selectedDocument !== "null" && this.props.selectedDocument !== undefined && this.props.selectedDocument.evrakSevkNots.length > 0 &&
                          <div className="FormRenk col-sm-12">
                              <span className="form-title">Not Ekleme</span>
                              <div className="row">
                                  <Label className="col-sm-3">Not: </Label>
                                  <div className={"col-sm-8 form-group" + this.validateClass('not')}>
                                      <textarea className="form-control uppercase"
                                                disabled={this.state.fieldsDisabled}
                                                name="not"
                                                id="not"
                                                maxLength="255"
                                                data-vlength="1,250"
                                                ref="not"
                                                onChange={(e) => this.onChangeDocumentNote("not", e.target.value)}
                                      />
                                      {this.validateMessage('not') !== "" &&
                                      <UncontrolledTooltip placement="right" target="not" delay={0}>
                                          {this.validateMessage("not")}
                                      </UncontrolledTooltip>}
                                  </div>
                              </div>
                          </div>
                      }


                        {/*{ !(this.props.selectedDocument !== null && this.props.selectedDocument !== "null" && this.props.selectedDocument !== undefined) ?*/}
                            <div className="FormRenk col-sm-12">
                                <span className="form-title">Evrağın Sevk Edileceği Birim</span>
                                <div className="row">
                                    <Label className="col-sm-3">Birim:</Label>
                                    <div className="col-sm-8 form-group">
                                        <Select
                                            // disabled={!this.state.hasTransfer}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Birim Seçiniz."
                                            isClearable={false}
                                            isSearchable={false}
                                            name="selectedGroups"
                                            id="selectedGroups"
                                            ref="selectedGroups"
                                            isMulti
                                            style={{width: 250, height: "100%"}}
                                            inputProps={{'vdata': "required"}}
                                            options={this.props.branches && this.props.branches.map((branch) => ({
                                                label: branch.label,
                                                value: branch.value
                                            }))}
                                            onChange={(value) => this.onSelectInfoChange("selectedGroups", value)}
                                            // onChange={(value) => this.onChangeSelect("selectedGroups", value)}
                                            value={this.state.documentInfo.selectedGroups}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <Label className="col-sm-3">Kişi:</Label>
                                    <div className="col-sm-8 form-group">
                                        <Select
                                            // disabled={!this.state.hasTransfer}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Birim Seçiniz."
                                            isClearable={false}
                                            isSearchable={false}
                                            name="selectedUsers"
                                            id="selectedUsers"
                                            ref="selectedUsers"
                                            isMulti
                                            style={{width: 250, height: "100%"}}
                                            inputProps={{'vdata': "required"}}
                                            options={this.props.roles && this.props.roles.map((rol) => ({
                                                label: rol.label,
                                                value: rol.value
                                            }))}
                                            onChange={(value) => this.onSelectInfoChange("selectedUsers", value)}
                                            value={this.state.documentInfo.selectedUsers}
                                        />
                                    </div>
                                </div>
                            </div>
                        {/*    :*/}
                        {/*    ""*/}
                        {/*}*/}
                    </Form>
                    <div className="save-button-container mb-5">
                        <button onClick={() => {
                            this.saveDocument("KAYDET")
                        }}
                                className="member-save-button"
                                disabled={this.state.isLoading || this.state.documentInfo.isTransferred}
                        >
                            {this.props.selectedDocument ? "TAMAM" : "KAYDET"}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default DocumentForm;



// WEBPACK FOOTER //
// ./src/page/documentList/DocumentForm.js